/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropbox_BrowseInputs */

const en_dropbox_browse = /** @type {(inputs: Dropbox_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse Dropbox files`)
};

const es_dropbox_browse = /** @type {(inputs: Dropbox_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorar archivos de Dropbox`)
};

/**
* | output |
* | --- |
* | "Browse Dropbox files" |
*
* @param {Dropbox_BrowseInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dropbox_browse = /** @type {((inputs?: Dropbox_BrowseInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropbox_BrowseInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dropbox_browse(inputs)
	return en_dropbox_browse(inputs)
});